<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2"> <v-icon left style="margin-right: 0">mdi-chevron-left</v-icon>返回 </span>
        </div>
        <v-card class="form-card card-padding">
          <h2 class="card-title">查看菜单</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
          </v-tabs>
          <v-card-text>
            <!-- <p>{{form}}</p> -->
            <v-form ref="form">
              <ul v-show="tabValue === 0" class="form-ul label-width-9">
                <li>
                  <span class="label">菜单code：</span>
                  <div class="text">{{ menu.code }}</div>
                </li>
                <li>
                  <span class="label">名称：</span>
                  <div class="text">{{ menu.name }}</div>
                </li>
                <li>
                  <span class="label">英文名称：</span>
                  <div class="text">{{ menu.nameEn }}</div>
                </li>
                <li>
                  <span class="label">用户类型：</span>
                  <div class="text">
                    <span v-if="menu.userType === 'common'" >
                      <!-- {{ item.userType }} -->
                      <span v-for="(item, i) in userTypeList" :key="i">
                        {{ item.name }}
                        <span v-if="i + 1 < userTypeList.length">&nbsp;/&nbsp;</span>
                      </span>
                    </span>
                    <span v-else-if="menu.userType">
                      <!-- {{ userTypeList.find((e) => e.label === menu.userType).name }} -->
                    </span>
                    <!-- {{ menu.userType ? userTypeList.find((e) => e.label === menu.userType).name : "" }} -->
                  </div>
                </li>
                <li>
                  <span class="label">平台类型：</span>
                  <div class="text">
                    <div v-if="menu.platType">
                      <span v-for="(ele, i) in menu.platType.split(',')" :key="i"> {{ platTypeList.find((e) => e.code === ele).name }} &nbsp;&nbsp; </span>
                    </div>
                    <!-- {{menu.platType ? platTypeList.find(e => e.code === menu.platType).name : ''}} -->
                  </div>
                </li>
                <template v-if="menu.extraConfig && menu.extraConfig.iconUrlMap">
                  <li class="li-file"  v-for="(value, key, i) in menu.extraConfig.iconUrlMap" :key="i">
                    <span class="label">{{ platTypeList.find((e) => e.code === key).name }}菜单图标：</span>
                    <div class="text flex text-center" style="width: 50%">
                      <div class="" v-for="(subVal, subKey, j) in value" :key="j">
                        <img v-if="subVal" :src="subVal" alt="" width="30" />
                        <div v-else style="color: #ccc; width: 30px; height: 30px; background: #eee; font-size: 12px; border-radius: 100%">暂无</div>
                        <p>{{ iconModeList[key].find((e) => e.code === subKey).name }}</p>
                      </div>
                    </div>
                  </li>
                </template>
                <template v-if="menu.extraConfig && menu.extraConfig.url">
                  <li class="li-file li-url">
                    <span class="label">菜单地址：</span>
                    <div class="text">
                      <div class="url-item" v-for="(item, i) in menu.extraConfig.url" :key="i">
                        <div>
                          <span class="lable">{{ item.name }}</span>
                          <div class="value">
                            <p>url：{{ item.url }}</p>
                            <p v-if="item.routingParameters === 1">route：{{ item.route }}</p>
                            <p v-if="item.appIdRequired === 1">appId：{{ item.appId }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </template>
                <!-- <li class="li-file">
                  <span class="label">菜单路由：</span>
                  <div class="text">
                    <div v-for="(value, key, i) in menu.extraConfig.routeMap" :key="i">
                      [{{platTypeLevel.find(e => e.code ===key).name}}] &nbsp;&nbsp; {{value}}
                    </div>
                  </div>
                </li> -->
                <!-- <li>
                  <span class="label">说明：</span>
                  <div class="text"> {{menu.description}}
                  </div>
                </li> -->
              </ul>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      colorText: ['indigo--text', 'deep-orange--text', 'teal--text'],
      tabValue: 0,
      menu: JSON.parse(sessionStorage.getItem('menuDetail'))
    }
  },
  computed: {
    ...mapState(['platTypeLevel', 'platTypeList', 'userTypeList', 'componentTypeList', 'iconDirectoryList', 'iconModeList'])
  },
  watch: {
  },
  beforeDestroy () {
  },
  created () {
  },
  mounted () {
    console.log(111111, this.menu.extraConfig)
  },
  methods: {
    back () {
      this.$router.back(-1)
      sessionStorage.removeItem('menuDetail')
    }
  }
}
</script>
<style>
.v-slider__thumb {
  cursor: pointer;
}
.li-url .url-item {
  border-bottom: 1px solid #eee;
  overflow: hidden;
  padding: 5px 0;
}
.li-url .url-item:last-child {
  border-bottom: 0;
}
.li-url .lable {
  margin-right: 10px;
  width: 100px;
  float: left;
  background-color: rgb(246, 246, 246);
  /* border: 1px solid #ccc; */
  text-align: center;
  border-radius: 4px;
}
.li-url .value {
  float: left;
}
.li-url p {
  margin-bottom: 0;
}
</style>
